export default __webpack_public_path__ + "static/ASLA_Tenza_3-06410bf169328aa459e5a9f3078d232e.png";